import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "65",
  height: "64",
  viewBox: "0 0 65 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_85_4107)" }, [
      _createElementVNode("path", {
        d: "M64.0962 29.8162L57.085 17.0558H50.022V12.059H5.88405V19.5957H0.0961914V23.3433H5.88405V26.7941H0.0961914V30.5416H5.88405V33.9198H0.0961914V37.6674H5.88405V41.5398H2.8444V45.2874H13.6246C13.9427 49.0091 17.0716 51.9411 20.8743 51.9411C24.677 51.9411 27.8059 49.0092 28.124 45.2874H40.8985C41.2166 49.0091 44.3455 51.9411 48.1482 51.9411C51.9508 51.9411 55.0798 49.0092 55.3978 45.2874H64.0962V29.8162ZM59.055 28.4234H50.0221V20.8033H54.8681L59.055 28.4234ZM20.8743 48.1935C18.9274 48.1935 17.3436 46.6097 17.3436 44.6628C17.3436 42.716 18.9274 41.132 20.8743 41.132C22.8212 41.132 24.405 42.716 24.405 44.6628C24.405 46.6097 22.8212 48.1935 20.8743 48.1935ZM41.5753 41.5398H27.4473C26.2763 39.0851 23.7704 37.3844 20.8744 37.3844C17.9784 37.3844 15.4726 39.0851 14.3016 41.5398H9.63161V37.6674H13.2127V33.9198H9.63161V30.5416H23.5392V26.7941H9.63161V23.3433H13.9622V19.5957H9.63161V15.8066H46.2744V37.6303C44.1983 38.1839 42.4845 39.6342 41.5753 41.5398ZM48.1483 48.1935C46.2015 48.1935 44.6176 46.6097 44.6176 44.6628C44.6176 42.716 46.2015 41.132 48.1483 41.132C50.0952 41.132 51.679 42.716 51.679 44.6628C51.679 46.6097 50.095 48.1935 48.1483 48.1935ZM54.7212 41.5398C53.812 39.6342 52.0982 38.1839 50.0221 37.6303V32.1709H53.3116V35.7936H57.0591V32.1709H60.3486V41.5398H54.7212Z",
        fill: "#002565"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_85_4107" }, [
        _createElementVNode("rect", {
          width: "64",
          height: "64",
          fill: "white",
          transform: "translate(0.0961914)"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }